<template>
  <div
    :class="{
      'flex justify-between overflow-auto': variant === 'row'
    }"
  >
    <Status
      v-for="status in statuses"
      :key="status"
      class="cursor-pointer"
      :is-flat="variant === 'row'"
      :is-active="selectedStatus === status"
      @click="handleActiveStatusChange(status)"
    >
      {{ $t(labelKeys[status], { count: countFor(status) }) }}
    </Status>
  </div>
</template>

<script>
import Status from '@/components/question-moderation/Status.vue'

export default {
  components: {
    Status,
  },
  props: {
    selectedStatus: {
      type: String,
      default: 'pending',
    },
    variant: {
      type: String,
      default: 'column',
    },
    questions: {
      type: Array,
      required: true,
    },
    handleActiveStatusChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      statuses: ['pending', 'approved', 'dismissed'],
      // The count is interpolated into the label, so each tab reuses the
      // presenter app's existing translated "<status> ({count})" strings.
      labelKeys: {
        pending: 'Pending ({count})',
        approved: 'Approved ({count})',
        dismissed: 'Dismissed ({count})',
      },
    }
  },
  methods: {
    countFor(status) {
      return this.questions.filter((question) => question.status === status).length
    },
  },
}
</script>
